<template>
  <div class="home bg" :class="(state.isLoading) ? 'is-loading' : 'loaded'">
      <LandscapeMessage />
      <Header></Header>

    
      <div class="navi-holder">
        <div class="arrow-holder" @click="arrowNav('left'); playTransition()"> <arrow arrow-class="arrow-left"></arrow></div>
        <hot-spot class="circle1 circle-nav" :class="[hotSpotIndex == 1 ? 'hotspot-on' : 'hotspot-off']" @click="handleClick(1); playTransition()" />
        <hot-spot class="circle2 circle-nav" :class="[hotSpotIndex == 2 ? 'hotspot-on' : 'hotspot-off']" @click="handleClick(2); playTransition()" />
        <hot-spot class="circle3 circle-nav" :class="[hotSpotIndex == 3 ? 'hotspot-on' : 'hotspot-off']" @click="handleClick(3); playTransition()" />
        <hot-spot class="circle4 circle-nav" :class="[hotSpotIndex == 4 ? 'hotspot-on' : 'hotspot-off']" @click="handleClick(4); playTransition()" />
        <hot-spot class="circle5 circle-nav" :class="[hotSpotIndex == 5 ? 'hotspot-on' : 'hotspot-off']" @click="handleClick(5); playTransition()" />
        <hot-spot class="circle6 circle-nav" :class="[hotSpotIndex == 6 ? 'hotspot-on' : 'hotspot-off']" @click="handleClick(6); playTransition()" />
        <hot-spot class="circle7 circle-nav" :class="[hotSpotIndex == 7 ? 'hotspot-on' : 'hotspot-off']" @click="handleClick(7); playTransition()" />
        <hot-spot class="circle8 circle-nav" :class="[hotSpotIndex == 8 ? 'hotspot-on' : 'hotspot-off']" @click="handleClick(8); playTransition()" />
        <hot-spot class="circle9 circle-nav" :class="[hotSpotIndex == 9 ? 'hotspot-on' : 'hotspot-off']" @click="handleClick(9); playTransition()" />
        <div class="arrow-holder" @click="arrowNav('right'); playTransition()"> <arrow arrow-class="arrow-right"></arrow> </div>
      </div>

       

      <div class="film-bg-top"></div>

       
    <FilmAnimation
    v-if="showTransition"  
    />

    <!-- <transition
      mode="in-out"> -->
      <router-view
        :transitionIn="transitionIn"
        :transitionOut="transitionOut"
      />  
    <!-- </transition> -->
  </div>
</template>

<script>


import { inject, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import Cookie from 'vue-cookie'
import gsap from 'gsap';
import LandscapeMessage from "@/views/LandscapeMessage";
import HotSpot from "@/components/HotSpot";
import Header from '@/components/particle/Header.vue'
import Arrow from "@/components/Arrow";

import FilmAnimation from "@/components/particle/FilmAnimation.vue";

// import Background from "@/views/Background.vue";

export default {
  components: {
    Header,
    Arrow,
    FilmAnimation,
    LandscapeMessage,
    HotSpot 
  },
  props: {
      hotspot: {type: String},
      index: {type: Number},
  },
  setup() { 
    const store = inject("store");
    const route = useRoute();
     const router = useRouter()

    console.log( route.path );

    const showTransition = ref(false);

    watch(
      () => store.state.activeLang,
      (activeLang, prevActiveLang) => {
        console.log('prevLang:', prevActiveLang);
        console.log('currentLang:', activeLang);

        if( prevActiveLang !== activeLang ) {
          hotSpotIndex.value = 1;
        }
      }
    )
    
      const arrowNav = (val) => {
        console.log("arrowNav " + val);
        if (val=="right"){
          if (hotSpotIndex.value < 9){
             hotSpotIndex.value = hotSpotIndex.value +=1;
          } else if (hotSpotIndex.value == 9) {
            hotSpotIndex.value = 1;
          }
        } else{
           if (hotSpotIndex.value > 1){
             hotSpotIndex.value = hotSpotIndex.value -= 1;
          } else if (hotSpotIndex.value == 1) {
            hotSpotIndex.value = 9;
          }
        }
          handleClick(hotSpotIndex.value);
    }

    const handleClick = (val) => {
      hotSpotIndex.value = val;
      store.actions.setHotspotState(true);
      switch (val) {
        case 1:
           setTimeout(() => {
        router.push(getTo("/slide-one"));
         }, 1000);
          break;
        case 2:
          routeHotSpotIndex = 2;
            setTimeout(() => {
        router.push(getTo("/slide-two"));
          }, 1000);
          break;
        case 3:
          setTimeout(() => {
        router.push(getTo("/slide-three"));
          }, 1000);
          break;
        case 4:
           setTimeout(() => {
        router.push(getTo("/slide-four"));
          }, 1000);
          break;
        case 5:
           setTimeout(() => {
        router.push(getTo("/slide-five"));
          }, 1000);
          break;
        case 6:
           setTimeout(() => {
        router.push(getTo("/slide-six"));
          }, 1000);
          break;
        case 7:
           setTimeout(() => {
        router.push(getTo("/slide-seven"));
          }, 1000);
          break;
        case 8:
           setTimeout(() => {
        router.push(getTo("/slide-eight"));
          }, 1000);
          break;
        case 9:
           setTimeout(() => {
        router.push(getTo("/slide-nine"));
          }, 1000);
          break;
        default:
          break;
      }
      }
      

    function getTo(localizedRoute) {
			const locale = Cookie.get('locale');
      // we strip leading and trailing slashes and prefix
      // the current locale
      return `/${locale}/${localizedRoute.replace(/^\/|\/$/g, "")}`
    }


    
    let routeHotSpotIndex = 1;

    // Modify this route check by checking how many slides there are
    if( route.path.match('slide-two') != null ) {
      routeHotSpotIndex = 2;
    } else if( route.path.match('slide-three') != null ) {
      routeHotSpotIndex = 3;
    } else if( route.path.match('slide-four') != null ) {
      routeHotSpotIndex = 4;
    
    } else if( route.path.match('slide-five') != null ) {
      routeHotSpotIndex = 5;
    
    } else if( route.path.match('slide-six') != null ) {
      routeHotSpotIndex = 6;
    
    } else if( route.path.match('slide-seven') != null ) {
      routeHotSpotIndex = 7;
    
    } else if( route.path.match('slide-eight') != null ) {
      routeHotSpotIndex = 8;
    
    } else if( route.path.match('slide-nine') != null ) {
      routeHotSpotIndex = 9;
    
    }

    const hotSpotIndex = ref(routeHotSpotIndex);
    const transitionIn = ref(false);
    const transitionOut = ref(false);

    return {
      actions: store.actions,
      state: store.state,

      showTransition,
      hotSpotIndex,
      transitionIn,
      transitionOut,
      handleClick,
      arrowNav
    }
    
  },	
  methods: {
    playTransition () {
      console.log('this.transitionOut', this.transitionOut);
      this.showTransition = true;
      this.transitionOut = true;
      setTimeout(() => {
        this.showTransition = false;
        this.transitionOut = false;
        // this.transitionIn = false;
      }, 2000);
    },
    // GSAP transitions
    beforeEnterLanding(el) {     
      gsap.set(el, { opacity: 0, x: -1200 });
    },
    enterLanding(el, done) {
			let that = this;

      let prodImg = new Image();
      prodImg.src = require('../assets/imgs/film-bg.png');
      prodImg.onload = () => {
        console.log('loaded loaded loaded');
        gsap.to(el, 1, { 
          opacity: 1, 
          x: 0,
          onComplete: function(){
            that.actions.showProduct(true);
            if(that.state.firstVisit) {
              that.actions.toggleIntro(true);
            }
            console.log("showHotspots kid")
            that.actions.showHotspots(true);
            done();
          } 
        }).delay(0.5);
      }

    },
    leaveLanding(el, done) {
			console.log('leaveLanding');
      gsap.to(el, 0.4, { opacity: 0, onComplete: done });
    },
    beforeEnterHotspot(el) {
      gsap.set(el, { opacity: 0, scale: 0});
    },
    enterHotspot(el, done) {
      gsap.to(el, 1, { 
				opacity: 0.8, 
				scale: 1.2,
				ease:'ease.easeOut',
			}).delay(3);
      gsap.to(el, 0.7, { 
				opacity: 1, 
				scale: 1,
				ease:'ease.easeIn',
				onComplete: done
			}).delay(0.7);
    },
  }
}
</script>

<style scoped lang="scss">
.home {
	transition: opacity 0.25s;
	opacity: 0;
	visibility: hidden;
}
.is-loading {
	visibility: hidden;
}
.loaded {
	visibility: visible;
	opacity: 1;
}
.router-link-exact-active {
  text-decoration: underline;
  font-weight: bold;
}

.film-bg-top {
  background: url("../assets/imgs/film-bg.png") bottom right repeat-x;
  height:15vh;
  min-height: 150px;
  min-width: 1200px;
  z-index: 50;
   background-size: auto;

   @media (max-width: 1200px)  {
        height:9em;
       background-size: cover;
  }
 
  @media (max-width: 600px)  {
        height:7em;
       background-size: cover;
  }
  @media only screen and (max-width: 414px) {
    min-height: 100px;
  }
}
.navi-holder{
  position:absolute;
  bottom:0px;
  height:3em;
  width: 100%;
  display: flex;
  justify-content: center;      
  z-index:2;
}

.arrow-holder{
  width:4em;
  height:inherit;
  display: flex;
  justify-content: center;
}

.bg {
  // background-image: url("../assets/imgs/bg.png");
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
}

@media screen and (min-width: 729px) {
   .film-bg-top {
      // height:20%;
  }
}

@media (max-width: 414px) {
  .navi-holder{
  height:2.2em; 
}

  .film-bg-top {
    overflow: hidden;
    // background-image: url("../assets/imgs/sm-film-bg.png");
    z-index: 50;
  }

  .bg {
    overflow: hidden;
    // background-image: url("../assets/imgs/sm-bg.png");
  }
}
</style>